<template>
    <div class="sell-card-header position-relative py-md-3">
        <b-badge
            class="new-label text-white position-absolute  ml-auto p-1"
            v-if="card.new"
        >
            NEW
        </b-badge>

        <b-img
            class="card-icon"
            :src="card.icon"
        />
        <b-row>
            <b-col>
                <h1 class="card-title mt-3">
                    {{ card.title }}
                </h1>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <p class="card-subtitle">
                    {{ card.subtitle }}
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './SellCardHeader.scss';
    export default {
        name: "SellCardHeader",

        props: {
            card: {
                type: Object,
                required: true,
            }
        }
    };
</script>
